import React, { useState, useEffect } from 'react';

interface Category {
  id: number;
  name: string;
  title: string;
  parentCategoryId: number | null;
}

interface CategoryFormProps {
  categories: Category[];
  selectedCategory: Category | null;
  onAddCategory: (category: Category) => void;
  onUpdateCategory: (category: Category) => void;
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  setSelectedCategory: (category: Category | null) => void;
}

const CategoryForm: React.FC<CategoryFormProps> = ({
  categories,
  selectedCategory,
  onAddCategory,
  onUpdateCategory,
  isEditing,
  setIsEditing,
  setSelectedCategory,
}) => {
  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [parentCategoryId, setParentCategoryId] = useState<number | null>(null);

  useEffect(() => {
    if (selectedCategory) {
      setName(selectedCategory.name);
      setTitle(selectedCategory.title);
      setParentCategoryId(selectedCategory.parentCategoryId);
    }
  }, [selectedCategory]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const category: Category = {
      id: selectedCategory ? selectedCategory.id : 0,
      name,
      title,
      parentCategoryId,
    };
    if (isEditing) {
      onUpdateCategory(category);
    } else {
      onAddCategory(category);
    }
    setName('');
    setTitle('');
    setParentCategoryId(null);
    setIsEditing(false);
    setSelectedCategory(null);
  };

  return (
    <section className='container categoryForm-section mt-5 pb-5'>
      <h2>{isEditing ? 'Edit Category' : 'Add Category'}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            id="title"
            name="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="parentCategory">Parent Category</label>
          <select
            id="parentCategory"
            name="parentCategory"
            value={parentCategoryId || ''}
            onChange={(e) => setParentCategoryId(parseInt(e.target.value, 10) || null)}
          >
            <option value="">None</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div className='button-area'>
        <div className='form-button'>
          <button type="submit">{isEditing ? 'Update' : 'Add'} Category</button>
          {isEditing && (
            <button
              type="button"
              className="btn btn-sm btn-outline-primary me-2 cancel"
              onClick={() => {
                setIsEditing(false);
                setSelectedCategory(null);
                setName('');
                setTitle('');
                setParentCategoryId(null);
              }}
            >
              Cancel
            </button>
          )}
        </div>
        </div>
      </form>
    </section>
  );
};

export default CategoryForm;